import momentZh from 'moment/locale/zh-cn';
import merchantIp from './zh/merchantip';
import transactionRecord from './zh/transactionRecord';
import transaction from './zh/transaction';
import userTransaction from './zh/userTransaction';
import withdrawBank from './zh/withdrawBank';
import withdraw from './zh/withdraw';
import merchantdeposit from './zh/merchantdeposit.js';
import passwd from './zh/passwd';
import home from './zh/home';
import btns from './zh/btns';
import status from './zh/status';
import wallet from './zh/walletRecord';
import channel from './zh/channel';
import orders from './zh/orders';
import clientmanage from './zh/clientmanage';
import accountmanager from './zh/accountmanager';
import menumanage from './zh/menumanage';
import rolemanager from './zh/rolemanager';
import merchantdetails from './zh/merchantdetails';
import login from './zh/login';
import merchantBalance from './zh/merchantBalance';
import welcome from './zh/welcome';
import channelTest from './zh/channelTest';
import momoLogs from './zh/momoLogs';
import usdt from './zh/usdt';
import sysConfig from './zh/sysConfig';
import channelList from './zh/channelList';
import device from './zh/device';

const components = {
  momentName: 'zh-cn',
  momentLocale: momentZh
};

const langs = {
  /* -------------------------------------------------------------------------- */
  /*                              @NOTE global 全局翻译                             */
  /* --------------------------------- 新增@TODO -------------------------------- */
  tips: {
    tip1: '这是一段内容确定删除吗？',
    tip2: '您有新的提现订单{money}元',
    tip3: '您有新的充值订单{money}元'
  },
  /* --------------------------------- 新增@TODO -------------------------------- */
  btns,
  status,
  /*                              @NOTE global 全局翻译                             */
  /* -------------------------------------------------------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                                @NOTE 页面翻译文件                                */
  momoLogs,
  merchantIp,
  transactionRecord,
  transaction,
  userTransaction,
  withdrawBank,
  withdraw,
  merchantdeposit,
  home,
  passwd,
  login,
  wallet,
  channel,
  orders,
  accountmanager,
  menumanage,
  rolemanager,
  clientmanage,
  merchantdetails,
  welcome,
  merchantBalance,
  channelTest,
  usdt,
  sysConfig,
  channelList,
  device
  /*                                @NOTE 页面翻译文件                                */
  /* -------------------------------------------------------------------------- */
};

export default { ...langs, ...components };



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js